import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import useModal from 'ui/partials/Modal/useModal';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { useParams } from 'react-router';

import c from '../utils/constants';

interface Payload {
  id: string;
  isComment?: boolean;
  noteId?: string;
  referenceId?: string;
  orderId?: string;
}

type PROPS = {
  onCancel?: () => void;
  referenceId?: string;
};

export default function useDeleteAttachment(props?: PROPS) {
  const queryClient = useQueryClient();
  const { hideModal } = useModal();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const { id } = useParams();
  const args = state;

  return useMutation({
    mutationFn: async ({ id }: Payload) => {
      const api = new Api(args);

      const data = await api.delete(
        await withAcl({
          account: {
            url: `api/v1/attachments/${id}`,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/attachments/${id}`,
          },
        }),
      );

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [c.LOGS, id] });
    },
    onSettled: (_, __, { id, isComment, noteId, referenceId }) => {
      if (isComment) {
        queryClient.invalidateQueries({
          queryKey: [c.NOTES, noteId, c.NOTE_COMMENT],
        });
        queryClient.invalidateQueries({
          queryKey: [c.NOTES, referenceId],
        });
      } else {
        if (noteId) {
          queryClient.setQueryData([c.NOTES, referenceId], (prevData: any) => {
            const newData = [...prevData];

            const index = newData.findIndex((note) => note._id === noteId);

            newData[index].attachments = newData[index].attachments.filter(
              (attachment: any) => attachment._id !== id,
            );

            return newData;
          });
        } else {
          queryClient.invalidateQueries({ queryKey: [c.TASK, referenceId] });
          queryClient.invalidateQueries({ queryKey: [c.ATTACHMENTS, {}] });
          queryClient.invalidateQueries({ queryKey: [c.NOTES] });
        }
      }

      queryClient.invalidateQueries({ queryKey: [c.LOGS, props?.referenceId] });

      toastSuccess('Successfully deleted attachment.');
      if (props?.onCancel) return props.onCancel();
      hideModal();
    },
  });
}

// const handleDeleteAttachment = useCallback(
//   (attachmentId: string) => {
//     deleteAttachment({
//       id: attachmentId,
//       noteId: data?._id,
//       referenceId: data?.referenceId,
//     });
//   },
//   [data, deleteAttachment],
// );
